// extracted by mini-css-extract-plugin
export var productImage = "_mq-1";
export var viewLink = "_mq-2";
export var wishlistItem = "_mq-0";